export const CheckInGuidedSelling = (props) => (<svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" viewBox="0 0 26 27" fill="none" {...props}>
        <path d="M20.9883 8.0741L10.2167 19.5106C9.80801 19.9446 9.14539 19.9446 8.7367 19.5106L4.24414 14.7408" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>);
